<template>

    <div>
        <app-header :settings="settings"></app-header>

        <div class="page__main container">
            <div class="page__index block">
                <div class="add-entity">
                    <div class="add-entity__form">
                        <div class="line-form b-form">
                            <div class="line-form__caption ex-small">
                                Укажите логин и пароль, выданный при заключении соглашения об использованиии Личного кабинета юридических лиц
                            </div>
                            <div class="line-form__body block-wrap">
                                <div class="line-form__col block">
                                    <label class="txt-input">
                                        <div class="txt-input__label">Логин</div>
                                        <div class="txt-input__input">
                                            <input class="txt-input__field input req" type="text" v-model="login">
                                        </div>
                                    </label>
                                </div>
                                <div class="line-form__col block">
                                    <label class="txt-input">
                                        <div class="txt-input__label">Пароль</div>
                                        <div class="txt-input__input">
                                            <input class="txt-input__field input req" type="password" v-model="password">
                                        </div>
                                    </label>
                                </div>
                                <div class="line-form__col line-form__col--total block">
                                    <a class="line-form__button button button--th-main"
                                       :class="[getStatusClass, getDisabledClass]"
                                       @click="addAccounts"
                                       v-if="accounts.length > 0">{{ isChecking ? '' : 'Добавить ЛС' }}</a>
                                    <a class="line-form__button button button--th-main"
                                       :class="[getStatusClass, getButtonClass]"
                                       @click="getAvailableAccounts"
                                       v-else>{{ isChecking ? '' : 'Поиск ЛС' }}</a>

                                </div>
                            </div>
                            <div class="line-form__body block-wrap" v-if="responseError">
                                <div class="line-form__col block">
                                    <p class="status-error">{{ responseError }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add-entity__list" v-if="accounts.length > 0">
                        <div class="form-list">
                            <div class="form-list__line">
                                <label class="radio-row">
                                    <input type="checkbox" name="profile" class="radio-row__radio" v-model="checkAll">
                                    <div class="radio-row__check radio-row__check--checkbox"></div>
                                    <div class="radio-row__body">
                                        <div class="radio-row__head">Выбрать все лицевые счета</div>
                                    </div>
                                </label>
                            </div>

                            <div class="form-list__line" v-for="account in accounts">
                                <label class="radio-row">
                                    <input type="checkbox" name="profile" class="radio-row__radio" v-model="selectedAccounts" :value="account">
                                    <div class="radio-row__check radio-row__check--checkbox"></div>
                                    <div class="radio-row__body">
                                        <div class="radio-row__head">{{ account.contragentFullName ? account.contragentFullName : account.contragentShortName }}, Договор № {{ account.contractNumber }} от {{ account.contractDate | formatDate }} с {{ account.division.caption }}</div>
                                        <div class="radio-row__right radio-row__right--cols">
                                            <div class="radio-row__caption h4">ЛС <span class="status-primary">{{ account.accountNumber }}</span></div>
                                            <div class="radio-row__status"><div class="status-primary">Активен</div></div>
                                        </div>
                                    </div>
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import ProfilesHeader from './ProfilesHeader.vue';

    export default {
        name: 'add-entity',
        data: function () {
            return {
                settings: {
                    name: 'personal',
                    isAddAccount: true,
                    addAccountHeader: 'Добавление лицевого счета юридического лица'
                },
                login: '',
                password: '',
                isChecking: false,
                responseStatus: false,
                responseError: '',
                accounts: [],
                selectedAccounts: []
            }
        },
        components: {
            'app-header': ProfilesHeader,
        },
        filters: {
            formatDate(value) {
                if (value)
                    return moment(value).format('DD.MM.YYYY');

                return "";
            }
        },
        computed: {
            getStatusClass() {
                return this.isChecking ? 'is-overlay' : ''
            },
            getButtonClass() {
                return !this.password || !this.login ? 'disabled' : ''
            },
            getDisabledClass() {
                return this.selectedAccounts.length > 0 ? '' : 'disabled'
            },
            checkAll: {
                get: function () {
                    return this.accounts ? this.selectedAccounts.length == this.accounts.length : false;
                },
                set: function (value) {
                    var self = this
                    var selected = [];

                    if (value && this.accounts) {
                        self.accounts.forEach(function (acc) {
                            selected.push(acc);
                        });
                    }

                    this.selectedAccounts = selected;
                }
            }
        },
        methods: {
            getAvailableAccounts() {
                var self = this

                self.isChecking = true
                self.responseStatus = false
                self.responseError = ''
                self.accounts = []

                axios.post('/Profiles/GetAvailableAccounts', {
                    Login: self.login.trim(),
                    Password: self.password.trim(),
                })
                    .then(function (response) {
                        self.responseStatus = response.data.success
                        self.responseError = response.data.responseError 

                        if (response.data.success)
                            self.accounts = response.data.data 
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                        self.isChecking = false;
                    });
            },
            addAccounts() {
                var self = this

                self.isChecking = true

                axios.post('/Profiles/AddAccounts', self.selectedAccounts)
                    .then(function (response) {
                        document.location.href = '/'
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {                        
                    });
            },
            checkAll() {
                this.selectedAccounts = [];

                if (!this.selectedAccounts) {
                    for (account in this.selectedAccounts) {
                        this.selectedAccounts.push(account);
                    }
                }
            }
        }
    }

</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/AddEntity.vue